import React, { useEffect } from 'react'
import {profile_information} from "../redux/ProfileSlice"
import { useDispatch } from 'react-redux';
import { decryptSecretKey,isObjectEmpty } from 'services/utils';
import { useProfileData } from './ProfileDetails';

export default function useRehydrate() {
    const dispatch=useDispatch();
    // let secretKey ; //undefined
    let secretKey = decryptSecretKey();
    let id_adminuser;
    let profile_data;


 if(secretKey){
  id_adminuser=localStorage.getItem('id_adminuser')
  profile_data=JSON.parse(localStorage.getItem('profile_data'))
 }

const profileData = useProfileData()

const getAdminDetails=()=>{
    if(secretKey && id_adminuser && profile_data  !== null){
        dispatch(
            profile_information({
              body: { id_adminuser: id_adminuser },
              user : {secretKey:secretKey, userName:profile_data.username}
            })
          );
    }
   
}


useEffect(()=>{
    
    if(profileData && isObjectEmpty(profileData?.profile_information_data)){
        getAdminDetails()
    }
 
 },[secretKey])


}
